import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-worker-alert-loops',
  templateUrl: './worker-alert-loops.component.html',
  styleUrls: ['./worker-alert-loops.component.scss']
})
export class WorkerAlertLoopsComponent implements OnInit {


  workers: any;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getWorkers();
  }

  getWorkers(){

    this.okService.get('reports/workeralertloops',{})
    .subscribe((data) => {

      this.workers = data.body;

    });
  }

  export(){

    this.okService.download("reports/workeralertloops",{export:true});

  }
}

